import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { Timestamp } from 'firebase/firestore';
import { FooterData } from '../types';
import { footerService } from '../services/firebase';

interface PageSectionsContextType {
  footerData: FooterData | null;
  loading: boolean;
  error: string | null;
  refetchFooterData: () => Promise<void>;
}

const PageSectionsContext = createContext<PageSectionsContextType | undefined>(undefined);

export const usePageSections = () => {
  const context = useContext(PageSectionsContext);
  if (context === undefined) {
    throw new Error('usePageSections must be used within a PageSectionsProvider');
  }
  return context;
};

interface PageSectionsProviderProps {
  children: ReactNode;
}

export const PageSectionsProvider: React.FC<PageSectionsProviderProps> = ({ children }) => {
  const [footerData, setFooterData] = useState<FooterData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFooterData = async () => {
    try {
      setLoading(true);
      setError(null);
      let data = await footerService.getFooterData();
      
      if (!data) {
        await footerService.initializeFooterData();
        data = await footerService.getFooterData();
      }
      
      setFooterData(data);
    } catch (err: any) {
      setError('Footer verileri yüklenirken hata oluştu: ' + err.message);
      console.error('Footer data fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFooterData();
  }, []);

  const refetchFooterData = async () => {
    await fetchFooterData();
  };

  const value: PageSectionsContextType = {
    footerData,
    loading,
    error,
    refetchFooterData
  };

  return (
    <PageSectionsContext.Provider value={value}>
      {children}
    </PageSectionsContext.Provider>
  );
}; 